import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'trip_list';
export const route = 'trip_list/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "tripList" */
'../../components/TripList')));